import {
  Row,
  Divider,
} from "antd";
import get from "lodash/get";
import round from "lodash/round";
import GraphGrid from "../graphGrid";
import { getTransformedMinutes } from "../../../utilities/helpers";

const InjectionMouldingContent = ({ selectedTemplate, filter, data }) => {
  return (
    <Row id="content-container ">
      <GraphGrid
        graphId={1}
        type="day"
        stats={get(data, "on_off_graph", [])}
        label={"On / Off / Idle"}
        statistics={[
          {
            value: getTransformedMinutes(
              get(selectedTemplate, "meta.total_off_hours", 0) ? round(get(selectedTemplate, "meta.total_off_hours", 0)) : 0
            ),
            // value:get(selectedTemplate, "meta.total_off_hours"),
            label: "Off Hours",
          },
          {
            value: getTransformedMinutes(
              get(selectedTemplate, "meta.total_idle_hours", 0) ? round(get(selectedTemplate, "meta.total_idle_hours", 0)) : 0
            ),
            label: "Idle  Hours",
          },
          {
            value: getTransformedMinutes(
              get(selectedTemplate, "meta.total_working_hours", 0) ? round(get(selectedTemplate, "meta.total_working_hours", 0)) : 0
            ),
            label: "Working Hours",
          },
        ]}
        selectedTemplate={selectedTemplate}
        filter={filter}
      />
      <Divider />
      <GraphGrid
        graphId={2}
        type="day"
        label={"Shots"}
        stats={get(data, "count_graph", [])}
        statistics={[
          {
            value: get(selectedTemplate, "meta.total_shots", 0) ? round(get(selectedTemplate, "meta.total_shots", 0)) : 0,
            label: "Shots",
          },
        ]}
        selectedTemplate={selectedTemplate}
        filter={filter}
      />
      <Divider />
      <GraphGrid
        type="day"
        graphId={3}
        label={"Open Time"}
        stats={get(data, "open_time_graph", [])}
        statistics={[
          {
            value: `${get(selectedTemplate, "meta.avg_open_time", 0) ? round(get(selectedTemplate, "meta.avg_open_time", 0)) : 0} Sec`,
            label: "Avg. Open Hours",
          },
        ]}
        selectedTemplate={selectedTemplate}
        filter={filter}
      />
      <Divider />
      <GraphGrid
        graphId={4}
        type="day"
        label={"Close Time"}
        stats={get(data, "close_time_graph", [])}
        statistics={[
          {
            value: `${get(selectedTemplate, "meta.avg_close_time", 0) ? round(get(selectedTemplate, "meta.avg_close_time", 0)) : 0} Sec`,
            label: "Avg. Close Hours",
          },
        ]}
        selectedTemplate={selectedTemplate}
        filter={filter}
      />
      <Divider />
      {get(data, "power_consumption_graph") && (
        <GraphGrid
          type="day"
          graphId={5}
          label={"Power Consumption"}
          stats={get(data, "power_consumption_graph", [])}
          statistics={[
            {
              value: `${get(
                selectedTemplate,
                "meta.total_power_consumption",
                0
              ) ? round(get(
                selectedTemplate,
                "meta.total_power_consumption",
                0
              )) : 0} Kwh`,
              label: "Power Consumption",
            },
          ]}
          selectedTemplate={selectedTemplate}
          filter={filter}
        />
      )}
    </Row>
  )
}

export default InjectionMouldingContent